import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import {
  PRACTICE_HOURS_CONTROLER_URL_ID,
  PRACTICE_HOURS_DISABLE_CONTROLER_URL,
} from "api/Service";
import { showMutationError } from "utils/showMutationError";

export const useTogglePracticeHourStatus = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${PRACTICE_HOURS_CONTROLER_URL_ID}${id}`
      );
      const givenData = response.data;
      await axiosInstance.post(
        `${tenantVal}${PRACTICE_HOURS_DISABLE_CONTROLER_URL}`,
        {
          day: givenData.day,
          dayNo: givenData.dayNo,
          disabled: !givenData.disabled,
          endTime: givenData.endTime,
          id,
          startTime: givenData.startTime,
          tenant: givenData.tenant,
        }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["practiceHours"] });
      queryClient.invalidateQueries({ queryKey: ["monthSlotCounts"] });
    },
    /*
     * A failed toggle used to say nothing at all: the switch simply snapped back on the
     * next refetch, which read as the click not registering rather than as a rejected
     * save. Reported the same way a failed hours update is.
     */
    onError: (error) =>
      showMutationError(error, "Failed to change the day's open status."),
    meta: { skipGlobalError: true },
  });
};
